export default __webpack_public_path__ + "static/media/blurLayer.87fa4468.png";